import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { PageHeader, Form, Input, Button, Spin, message } from 'antd';

import * as ToolRequest from '../../tools/ToolRequest';

import SpinFull from '../../components/SpinFull';

const formLayout = {
  labelCol: {
    sm: { span: 5 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 5, span: 16 },
  },
};

export default function CompanyEditScreen() {
  const history = useHistory();
  const { companyId } = useParams();

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    (async () => {
      const companyRes = await ToolRequest.request('GET', `/v1/company/${companyId}`);
      setCompany(companyRes);
      setLoaded(true);
    })();
  }, [companyId]);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      await ToolRequest.request('PUT', `/v1/company/${companyId}`, {
        displayName: values.displayName.trim(),
      });

      message.success('Update Company successfully');

      history.push('/company');
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          case 'INVALID_PARAMS':
            return message.error('Invalid parameters. Please check your inputs');
          case 'NOT_FOUND':
            return message.error('Company not found');
          default:
            return message.error('Unknown errors. Please retry');
        }
      }

      message.error('Unknown error. Please retry');
    }
  };

  return loaded ? (
    <PageHeader
      title={`Edit Company (${company.displayName})`}
      onBack={() => history.push('/company')}
    >
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          initialValues={company}
          onFinish={onFinish}
        >
          <Form.Item
            label="Name"
            name="name"
          >
            <Input disabled />
          </Form.Item>

          <Form.Item
            label="Display Name"
            name="displayName"
            rules={[
              {
                required: true,
                message: 'Please enter the display name',
              },
            ]}
          >
            <Input
              placeholder="Display name"
            />
          </Form.Item>

          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageHeader>
  ) : <SpinFull />;
}

